// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.Rules_wrapper__DshCu {
  height: 100vh;
  padding: 20px 10% 120px 10%;
  gap: 10px;
  overflow-y: auto;
}

.Rules_wrapper__DshCu h1 {
  font-style: normal;
  font-weight: 500;
  font-size: 25px;
  line-height: 40px;
  color: var(--primary-color);
  text-decoration: underline;
  text-align: center;
}

.Rules_wrapper__DshCu h2 {
  font-style: normal;
  font-weight: 500;
  font-size: 18px;
  line-height: 40px;
  color: var(--primary-color);
}

.Rules_tabsContainer__iOc0W {
  display: flex;
  gap: 1rem;
  border-bottom: 1px solid #ddd;
  padding-bottom: 0.5rem;
  margin-bottom: 1rem;
  flex-wrap: wrap; /* allows wrapping on smaller screens */
}

.Rules_tab__D88pG {
  position: relative;
  cursor: pointer;
  padding: 0.5rem;
  font-weight: 600;
  white-space: nowrap;
}

.Rules_tab__D88pG.Rules_active__E-A8G {
  color: var(--primary-color);
}

.Rules_underline__2TxIm {
  position: absolute;
  bottom: -6px;
  left: 0;
  right: 0;
  height: 3px;
  background-color: var(--primary-color);
  border-radius: 1px;
}

.Rules_termsContent__1b\\+xd {
  font-size: 16px;
  line-height: 1.6;
}

/* MOBILE VERSION */
@media (max-width: 768px) {
  .Rules_wrapper__DshCu {
    padding: 15px 20px 80px 20px;
  }

  .Rules_wrapper__DshCu h1 {
    font-size: 20px;
    line-height: 30px;
    margin-bottom: 20px;
  }

  .Rules_tabsContainer__iOc0W {
    flex-direction: column;
    gap: 0.5rem;
    border-bottom: none;
  }

  .Rules_tab__D88pG {
    font-size: 14px;
    padding: 0.6rem 0.8rem;
    border: 1px solid #ddd;
    border-radius: 6px;
  }

  .Rules_tab__D88pG.Rules_active__E-A8G {
    background-color: var(--primary-color);
    color: #fff;
  }

  .Rules_underline__2TxIm {
    display: none; /* hide underline for compact layout */
  }

  .Rules_termsContent__1b\\+xd {
    font-size: 14px;
    line-height: 1.5;
  }
}`, "",{"version":3,"sources":["webpack://./src/components/Rules.module.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,2BAA2B;EAC3B,SAAS;EACT,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,2BAA2B;EAC3B,0BAA0B;EAC1B,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,2BAA2B;AAC7B;;AAEA;EACE,aAAa;EACb,SAAS;EACT,6BAA6B;EAC7B,sBAAsB;EACtB,mBAAmB;EACnB,eAAe,EAAE,uCAAuC;AAC1D;;AAEA;EACE,kBAAkB;EAClB,eAAe;EACf,eAAe;EACf,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,kBAAkB;EAClB,YAAY;EACZ,OAAO;EACP,QAAQ;EACR,WAAW;EACX,sCAAsC;EACtC,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,gBAAgB;AAClB;;AAEA,mBAAmB;AACnB;EACE;IACE,4BAA4B;EAC9B;;EAEA;IACE,eAAe;IACf,iBAAiB;IACjB,mBAAmB;EACrB;;EAEA;IACE,sBAAsB;IACtB,WAAW;IACX,mBAAmB;EACrB;;EAEA;IACE,eAAe;IACf,sBAAsB;IACtB,sBAAsB;IACtB,kBAAkB;EACpB;;EAEA;IACE,sCAAsC;IACtC,WAAW;EACb;;EAEA;IACE,aAAa,EAAE,sCAAsC;EACvD;;EAEA;IACE,eAAe;IACf,gBAAgB;EAClB;AACF","sourcesContent":[".wrapper {\n  height: 100vh;\n  padding: 20px 10% 120px 10%;\n  gap: 10px;\n  overflow-y: auto;\n}\n\n.wrapper h1 {\n  font-style: normal;\n  font-weight: 500;\n  font-size: 25px;\n  line-height: 40px;\n  color: var(--primary-color);\n  text-decoration: underline;\n  text-align: center;\n}\n\n.wrapper h2 {\n  font-style: normal;\n  font-weight: 500;\n  font-size: 18px;\n  line-height: 40px;\n  color: var(--primary-color);\n}\n\n.tabsContainer {\n  display: flex;\n  gap: 1rem;\n  border-bottom: 1px solid #ddd;\n  padding-bottom: 0.5rem;\n  margin-bottom: 1rem;\n  flex-wrap: wrap; /* allows wrapping on smaller screens */\n}\n\n.tab {\n  position: relative;\n  cursor: pointer;\n  padding: 0.5rem;\n  font-weight: 600;\n  white-space: nowrap;\n}\n\n.tab.active {\n  color: var(--primary-color);\n}\n\n.underline {\n  position: absolute;\n  bottom: -6px;\n  left: 0;\n  right: 0;\n  height: 3px;\n  background-color: var(--primary-color);\n  border-radius: 1px;\n}\n\n.termsContent {\n  font-size: 16px;\n  line-height: 1.6;\n}\n\n/* MOBILE VERSION */\n@media (max-width: 768px) {\n  .wrapper {\n    padding: 15px 20px 80px 20px;\n  }\n\n  .wrapper h1 {\n    font-size: 20px;\n    line-height: 30px;\n    margin-bottom: 20px;\n  }\n\n  .tabsContainer {\n    flex-direction: column;\n    gap: 0.5rem;\n    border-bottom: none;\n  }\n\n  .tab {\n    font-size: 14px;\n    padding: 0.6rem 0.8rem;\n    border: 1px solid #ddd;\n    border-radius: 6px;\n  }\n\n  .tab.active {\n    background-color: var(--primary-color);\n    color: #fff;\n  }\n\n  .underline {\n    display: none; /* hide underline for compact layout */\n  }\n\n  .termsContent {\n    font-size: 14px;\n    line-height: 1.5;\n  }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"wrapper": `Rules_wrapper__DshCu`,
	"tabsContainer": `Rules_tabsContainer__iOc0W`,
	"tab": `Rules_tab__D88pG`,
	"active": `Rules_active__E-A8G`,
	"underline": `Rules_underline__2TxIm`,
	"termsContent": `Rules_termsContent__1b+xd`
};
export default ___CSS_LOADER_EXPORT___;
